<template>
  <div class="login">
    <div class="box">
      <div class="tap-menu">
        <div
          class="user"
          @click="setUserType('user')"
          :class="{ 'selected-box': form.type === 'user' }"
        >
          <span class="text" :class="{ selected: form.type === 'user' }"
            >USER</span
          >
        </div>
        <div
          class="photographer"
          @click="setUserType('photographer')"
          :class="{ 'selected-box': form.type === 'photographer' }"
        >
          <span class="text" :class="{ selected: form.type === 'photographer' }"
            >PHOTOGRAPHER</span
          >
        </div>
      </div>
      <div class="tab-body">
        <div class="title">
          <span>Sign up</span>
        </div>
        <div class="social-box">
          <div class="facebook" @click="facebook">
            <img src="../../../assets/images/social_icon/facebook.svg" />
          </div>
          <div class="twitter" @click="twitter">
            <img src="../../../assets/images/social_icon/twitter.svg" />
          </div>
        </div>
        <div class="or">
          <span>OR</span>
        </div>
        <div class="form">
          <form v-on:submit.prevent="addUser">
            <input-email
              :email="form.email"
              v-on:model="v => (form.email = v)"
              :required="true"
            ></input-email>
            <input-password
              :password="form.password"
              v-on:model="v => (form.password = v)"
              :required="true"
            ></input-password>
            <input-text
              :value="form.name"
              v-on:model="v => (form.name = v)"
              :placeholder="'NAME'"
              :required="true"
            ></input-text>
            <hr />
            <div class="form-login">
              <input-button
                class="input-button"
                text="Cerate"
                width="260px"
              ></input-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defaultAuth,
  firebaseConnection,
  defaultStore
} from '../../../library/firebase'
import {
  InputEmail,
  InputPassword,
  InputText,
  InputButton
} from '../../common/form-elemnets'
import * as types from '../../../store/mutation-types'

export default {
  name: 'signup',
  components: {
    InputPassword,
    InputEmail,
    InputText,
    InputButton
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
        name: '',
        type: 'user',
        emailVerified: false,
        creationTime: firebaseConnection.firestore.FieldValue.serverTimestamp()
      }
    }
  },
  methods: {
    addUser() {
      console.log('add user', this.form)
      defaultAuth
        .createUserWithEmailAndPassword(
          this.form.email,
          this.form.password.toString()
        )
        .then(result => {
          console.log('sign up info:', result.user)
          // delete this.form['password']
          defaultStore
            .collection('users')
            .doc(result.user.uid)
            .set(this.form)
            .then(docRef => {
              console.log('Document written with ID: ', docRef)
            })
            .then(() => {
              this.$store.dispatch(types.SET_MODAL_COMPONENT, {
                component: 'login',
                active: true,
                type: 'full'
              })
            })
            .catch(this.signupFialsDelete)
        })
        .catch(error => {
          this.signupFialsDelete(error)
          // Handle Errors here.
          const errorCode = error.code
          const errorMessage = error.message
          alert(errorCode + '\n' + errorMessage)
        })
    },
    signupFialsDelete(e) {
      console.log('Signup fails delete user.', e)
      const user = defaultAuth.currentUser
      // User deleted.
      user
        .delete()
        .then(r => {
          console.log('delete success', r)
        })
        .catch(error => {
          // An error happened.
          console.log(error)
        })
    },
    facebook() {
      const provider = new firebaseConnection.auth.FacebookAuthProvider()
      defaultAuth
        .signInWithPopup(provider)
        .then(result => {
          // console.log('facebook', result)
          // This gives you a Facebook Access Token.
          const token = result.credential.accessToken
          // The signed-in user info.
          const user = result.additionalUserInfo.profile
          const uid = result.user.uid
          console.log('sign up info:', result)
          const userForm = {
            name: user.name,
            firstName: user.first_name,
            lastName: user.last_name,
            birthday: user.birthday,
            email: user.email,
            facebookId: user.id,
            facebookLink: user.link,
            locale: user.locale,
            gender: user.gender,
            emailVerified: result.user.emailVerified,
            creationTime: new Date(result.user.metadata.creationTime),
            lastSignInTime: new Date(result.user.metadata.lastSignInTime),
            photoUrl: user.picture.data.url,
            facebookAccessToken: token,
            ageRangeMin: user.age_range.min,
            timezone: user.timezone,
            facebookVerified: user.verified,
            providerId: result.additionalUserInfo.providerId
          }

          if (result.additionalUserInfo.isNewUser) {
            // new user
            userForm.type = this.form.type
            this.$store
              .dispatch(types.SET_SIGNUP, { user: userForm, uid: uid })
              .then(this.goToMain)
          } else {
            this.$store
              .dispatch(types.UPDATE_USERINFO, {
                form: userForm,
                uid: uid
              })
              .then(() => {
                console.log('user information updated')
              })
          }
        })
        .catch(this.signupFialsDelete)
    },
    twitter() {
      const provider = new firebaseConnection.auth.TwitterAuthProvider()
      defaultAuth.signInWithPopup(provider).then(() => {
        // For accessing the Twitter API.
        // const token = result.credential.accessToken
        // const secret = result.credential.secret
        // The signed-in user info.
        // const user = result.user
      })
    },
    setUserType(type) {
      this.form.type = type
    },
    goToMain() {
      this.$store
        .dispatch(types.SET_MODAL_COMPONENT, {
          component: '',
          active: false,
          type: 'full'
        })
        .then(() => {
          this.$router.push({ path: '/main' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  margin: auto;
  background-color: white;
  width: 480px;
  height: 572px;
  .box {
    position: relative;
    margin: auto;
    background-color: #ffffff;
    border: 1px solid darkgray;
    width: inherit;
    height: inherit;

    .tap-menu {
      position: relative;
      height: 60px;
      width: 100%;
      /*overflow: hidden;*/
      display: -webkit-flex;
      display: flex;
      -webkit-flex-direction: row;
      flex-direction: row;
      .user {
        min-width: 50%;
        height: inherit;
        text-align: center;
        border-right: solid 1px #e7e7e7;
        border-bottom: solid 1px #e7e7e7;
        -webkit-flex: auto;
        flex: auto;
        vertical-align: middle;
        line-height: 60px;
      }

      .photographer {
        height: inherit;
        vertical-align: middle;
        border-bottom: solid 1px #e7e7e7;
        text-align: center;
        -webkit-flex: auto;
        flex: auto;
        min-width: 50%;
        line-height: 60px;
      }

      .selected-box {
        border-bottom: 0;
      }

      .selected {
        font-weight: 600 !important;
        color: #ab08b6 !important;
      }

      .text {
        cursor: pointer;

        font-size: 16px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        text-align: center;
        color: #000000;
      }
    }

    .tab-body {
      position: relative;
      margin: 29px 70px auto 70px;
      left: 0;
      right: 0;
      height: auto;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;

      .title {
        width: 87px;
        height: 26px;

        span {
          font-size: 16px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: 1px;
          line-height: 26px;
          color: #000000;
        }
      }

      .social-box {
        margin: 16px 0 0 0;
        position: relative;
        height: 60px;
        width: 250px;
        overflow: hidden;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;

        img {
          position: absolute;
          margin: auto;
          left: 0;
          right: 0;
          width: 100px;
          top: -20px;
        }

        .facebook {
          margin: 0 20px 0 0;
          position: relative;
          -webkit-flex: auto;
          flex: auto;
          min-width: 40%;
          border: 1px solid #eaeaea;
          overflow: hidden;
        }

        .twitter {
          position: relative;
          -webkit-flex: auto;
          flex: auto;
          min-width: 40%;
          border: 1px solid #eaeaea;
          overflow: hidden;
        }
      }

      .or {
        width: 25px;
        height: 26px;
        position: relative;
        margin: 20px auto 0 auto;

        span {
          font-size: 16px;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: 1px;
          color: #000000;
        }
      }
    }

    .form {
      margin: 0;
      display: flex;
      justify-content: center;
      input {
        width: 260px;
        height: 50px;
        font-size: 14px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        color: #000000;
        padding: 0 16px 0 16px;
        margin: 10px 0 0 0;
        background-color: #ffffff;
        border: solid 1px #e7e7e7;
        outline: none;
      }

      .forget-password {
        position: relative;
        margin: 5px 0 0 0;
        float: right;
        span {
          font-size: 14px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #0f00ff;
        }
      }

      hr {
        margin: 37px 0 0 0;
        border-color: #e7e7e7;
      }

      .remember {
        width: 140px;
        position: relative;
        margin: 8px auto 0 auto;

        label {
          height: 0;
          margin: 0;
        }

        span {
          line-height: 20px;

          font-size: 16px;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #000000;
        }

        input[type='checkbox'] {
          width: 20px;
          height: 20px;
          opacity: 0.54;
          border: solid 1px #000000;
          background-color: #ffffff;
          position: relative;
          top: 5px;
        }
      }

      .form-login {
        position: relative;
        margin: 20px auto auto auto;
        width: 260px;
        height: 50px;
        button {
          width: 260px;
          height: 50px;
          border-radius: 2px;
          background-color: #000bff;
          border: 0;
        }

        span {
          font-size: 14px;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: 1px;
          text-align: center;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
